import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MessageProvider } from "@cadenza/messages";
import { ThemeProvider } from "@cadenza/theme";
import RADDataProvider from "./RADDataProvider";
import { I18nProvider } from "@cadenza/i18n-react";
import { HistoryProvider } from "@cadenza/history-react";
import { EditorPreferencesProvider } from "@cadenza/preferences";
import { resolveApiBase, setApiBase } from "@cadenza/io-utils";
import { initSession } from "./auth/session.js";
import App from "./App.jsx";

import "@cadenza/theme/styles.css";

const API_BASE = resolveApiBase("/api");

setApiBase(API_BASE);
initSession(API_BASE);

if (import.meta.env.MODE === "development") {
  document.title = "RAD Tool (Dev)";
  const base = import.meta.env.BASE_URL; // respects publicDir + subpaths

  const setIcon = (rel) => {
    const selector = `link[rel="${rel}"]`;
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement("link");
      el.rel = rel;
      document.head.appendChild(el);
    }
    // cache-bust so browsers actually swap it
    el.href = `${base}cslogo.png?v=${Date.now()}`;
  };

  ["icon", "shortcut icon", "apple-touch-icon"].forEach(setIcon);
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <MessageProvider>
        <ThemeProvider>
          <I18nProvider>
            <HistoryProvider initialState={[]}>
              <RADDataProvider>
                <EditorPreferencesProvider>
                  <App />
                </EditorPreferencesProvider>
              </RADDataProvider>
            </HistoryProvider>
          </I18nProvider>
        </ThemeProvider>
      </MessageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
